'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _reduxForm = require('redux-form');

var _helpers = require('../../helpers');

var _formFields = require('../form-fields');

var _dictionaries = require('../../dictionaries');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegisterForm = (0, _reduxForm.reduxForm)({ form: 'register', initialValues: { country: 'US' } })(function (props) {
  var handleSubmit = props.handleSubmit,
      submitting = props.submitting,
      register = props.register;


  return _react2.default.createElement(
    'form',
    { onSubmit: handleSubmit(register) },
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required],
      name: 'firstName',
      label: 'First Name',
      autoComplete: 'given-name'
    }),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required],
      name: 'lastName',
      label: 'Last Name',
      autoComplete: 'family-name'
    }),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.DropDownMenu,
      validate: [_helpers.required],
      name: 'country',
      label: 'Country',
      options: _dictionaries.countries.options
    }),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required, _helpers.email],
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'you@example.com',
      autoComplete: 'email'
    }),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.TextField,
      validate: [_helpers.required, _helpers.minLength8],
      name: 'password',
      label: 'Password',
      type: 'password',
      placeholder: 'Create a password',
      autoComplete: 'new-password'
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement(_reduxForm.Field, {
      component: _formFields.Checkbox,
      validate: [_helpers.required],
      name: 'termsAccepted',
      label: _react2.default.createElement(
        'div',
        null,
        'I have read and understood the\xA0',
        _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'link-style', target: '_blank', to: '/terms' },
          'Terms and Conditions'
        ),
        '\xA0and\xA0',
        _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'link-style', target: '_blank', to: '/privacy' },
          'Privacy Policy'
        ),
        '.'
      )
    }),
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement('br', null),
    _react2.default.createElement('input', {
      type: 'submit',
      value: 'Register',
      disabled: submitting,
      className: 'button w-button ' + (submitting ? 'disabled-btn' : null)
    })
  );
});

exports.default = RegisterForm;